import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import ListHtmlRenderer from './Renderer/ListHtmlRenderer';
const ListControls = lazyLoad(() => import('./Controls/ListControls'));
export default (settings) => {
    const plugin = createPlugin(Object.assign({ Controls: ListControls, Renderer: ListHtmlRenderer }, settings));
    return plugin;
};
//# sourceMappingURL=index.js.map